var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBread(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 24.62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#2c3e50;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2037",
    "data-name": "Path 2037",
    className: "cls-1",
    d: "M30,7.63c-.16.48-.28,1-.47,1.43a5.55,5.55,0,0,1-1.5,2,1,1,0,0,0-.38.84c0,3.24,0,6.49,0,9.73a2.94,2.94,0,0,1-2.87,3H5.34a2.93,2.93,0,0,1-3-2.87v-.13c0-3.27,0-6.54,0-9.81A.88.88,0,0,0,2,11.09,5.87,5.87,0,0,1,.24,8.49,4.61,4.61,0,0,1,.9,4.29a8.84,8.84,0,0,1,3.89-3A16,16,0,0,1,11.22,0h7.23a16.94,16.94,0,0,1,6.1,1.07,10.62,10.62,0,0,1,3.84,2.39,5.37,5.37,0,0,1,1.55,2.88l.06.17ZM11.31,23.45h5.83a2.72,2.72,0,0,0,.69-.09,1.76,1.76,0,0,0,1.27-1.85V11.27a.9.9,0,0,1,.35-.75,10.71,10.71,0,0,0,1.24-1.28,3.51,3.51,0,0,0,.12-4.15,6.71,6.71,0,0,0-2.49-2.21A13.64,13.64,0,0,0,13,1.29a15.59,15.59,0,0,0-6.88.79,8.44,8.44,0,0,0-4,2.63,3.48,3.48,0,0,0-.55,3.82,5.12,5.12,0,0,0,1.64,2,.87.87,0,0,1,.36.75c0,3.4,0,6.79,0,10.19a2.23,2.23,0,0,0,.09.72,1.74,1.74,0,0,0,1.81,1.27h5.89m8.37,0h4.79a1.13,1.13,0,0,0,.26,0,2.33,2.33,0,0,0,.46-.08,1.76,1.76,0,0,0,1.29-1.83V11.26a.91.91,0,0,1,.34-.73,11.55,11.55,0,0,0,1.24-1.28A3.41,3.41,0,0,0,28.82,7a3.68,3.68,0,0,0-.95-2.3A8.86,8.86,0,0,0,24.1,2.19a14.83,14.83,0,0,0-4.21-.92c-.72-.05-1.45,0-2.17,0l.76.36a8.74,8.74,0,0,1,3,2.3,4.68,4.68,0,0,1,.89,4.76,5.8,5.8,0,0,1-1.75,2.45.79.79,0,0,0-.3.67c0,3.06,0,6.13,0,9.19a3.71,3.71,0,0,1-.6,2.47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2038",
    "data-name": "Path 2038",
    className: "cls-1",
    d: "M15.29,10.13a2.47,2.47,0,0,1-.31.52q-3.25,3.27-6.5,6.51a.6.6,0,0,1-1-.71.53.53,0,0,1,.13-.13l6.5-6.5a.57.57,0,0,1,.71-.17,2.22,2.22,0,0,1,.44.48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2039",
    "data-name": "Path 2039",
    className: "cls-1",
    d: "M10.32,10.13a2.51,2.51,0,0,1-.32.52c-.77.8-1.56,1.59-2.35,2.37a.6.6,0,1,1-1-.7l.14-.14L9.17,9.82a.57.57,0,0,1,.71-.17,2.22,2.22,0,0,1,.44.48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2040",
    "data-name": "Path 2040",
    className: "cls-1",
    d: "M13,17.4a.6.6,0,0,1-.63-.57.52.52,0,0,1,.06-.3,1,1,0,0,1,.18-.23L15,14c.41-.4,1-.29,1.06.23a.75.75,0,0,1-.17.55c-.8.83-1.62,1.64-2.44,2.44a1.11,1.11,0,0,1-.37.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2041",
    "data-name": "Path 2041",
    className: "cls-1",
    d: "M11.32,9.1a.57.57,0,0,1-.59-.55v0a.58.58,0,0,1,1.16,0v0a.57.57,0,0,1-.57.57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2042",
    "data-name": "Path 2042",
    className: "cls-1",
    d: "M11.89,18.46a.58.58,0,0,1-1.16,0h0a.58.58,0,0,1,1.16,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2043",
    "data-name": "Path 2043",
    className: "cls-1",
    d: "M23,17.18c0-1.44,0-2.87,0-4.3a1.09,1.09,0,0,1,.3-.79,7.55,7.55,0,0,0,2-5c0-.42.25-.66.6-.65s.58.26.57.7a8.3,8.3,0,0,1-1.94,5.23,1.6,1.6,0,0,0-.4,1.13c0,2.64,0,5.29,0,7.93v.27a.59.59,0,0,1-.57.55.58.58,0,0,1-.6-.54v0c0-.56,0-1.13,0-1.7V17.18"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBread);
export default __webpack_public_path__ + "static/media/bread.335c3f5c76f929423ce79e5c5029af9c.svg";
export { ForwardRef as ReactComponent };